/* STEP 7d · D-a (owner decision, Add-on Card V1, 30-Oct-2026) — the own-key card and dialog of the tenant AI Usage page,
   white-label: the two AI providers are "AI provider 1" / "AI provider 2"; no provider name, model id or key prefix.
   The Founder AI Keys pages keep the provider names (their own texts). EN + AR.
   Loaded from lib/i18n/ by the generated index (STEP 2 · B2). */
export const I18N_S7D_A = {
  en: {
    s7da: {
      providerLabel: "Provider",
      provider_1: "AI provider 1",
      provider_2: "AI provider 2",
      mode: "Mode",
      suffix: "Suffix",
      keyLabel: "API key",
      keyPlaceholder: "Paste the key from your AI provider",
      keyHint: "Get the key from your AI provider's console. AZEX checks that the key fits the provider you chose.",
      modelNote: "AZEX uses the recommended model of the provider you choose.",
      testTitle: "Test key against the provider",
      testDesc: "A short call to the AI provider. Required before saving.",
      test: "Test key",
      testing: "Testing…",
      accepted: "Key accepted by the provider",
      rejected: "Key rejected",
      cancel: "Cancel",
      save: "Save key",
      saving: "Saving…",
      testFirst: "Test key first",
      errEmpty: "The API key is empty.",
      errShort: "That key is too short. Please check it.",
      errTestFirst: "Please run 'Test key' successfully before saving.",
      saved: "Own key saved. The next AI call will use your key.",
      switchedPlatform: "Switched back to the platform key",
      confirmPlatform: "Switch back to the platform key? Your own key will be removed from AZEX.",
      saveFailed: "Save failed",
      testFailed: "Test failed",
      switchFailed: "Switch failed",
      fixModelRetired: "Fix: open the dialog below and save your key again. AZEX then uses the provider's current recommended model. Your key is still valid; only the saved model was retired.",
    },
  },
  ar: {
    s7da: {
      providerLabel: "المزوّد",
      provider_1: "مزوّد الذكاء الاصطناعي 1",
      provider_2: "مزوّد الذكاء الاصطناعي 2",
      mode: "الوضع",
      suffix: "آخر الأحرف",
      keyLabel: "مفتاح API",
      keyPlaceholder: "الصق المفتاح من مزوّد الذكاء الاصطناعي",
      keyHint: "احصل على المفتاح من لوحة التحكم لدى مزوّد الذكاء الاصطناعي. تتحقق AZEX من أن المفتاح يطابق المزوّد الذي اخترته.",
      modelNote: "تستخدم AZEX النموذج الموصى به لدى المزوّد الذي تختاره.",
      testTitle: "اختبار المفتاح لدى المزوّد",
      testDesc: "استدعاء قصير لمزوّد الذكاء الاصطناعي. مطلوب قبل الحفظ.",
      test: "اختبار المفتاح",
      testing: "جارٍ الاختبار…",
      accepted: "قبِل المزوّد المفتاح",
      rejected: "رُفض المفتاح",
      cancel: "إلغاء",
      save: "حفظ المفتاح",
      saving: "جارٍ الحفظ…",
      testFirst: "اختبر المفتاح أولًا",
      errEmpty: "مفتاح API فارغ.",
      errShort: "هذا المفتاح قصير جدًا. يُرجى التحقق منه.",
      errTestFirst: "يُرجى تشغيل «اختبار المفتاح» بنجاح قبل الحفظ.",
      saved: "تم حفظ المفتاح الخاص. سيستخدم استدعاء الذكاء الاصطناعي التالي مفتاحك.",
      switchedPlatform: "تمت العودة إلى مفتاح المنصة",
      confirmPlatform: "العودة إلى مفتاح المنصة؟ سيُزال مفتاحك الخاص من AZEX.",
      saveFailed: "تعذّر الحفظ",
      testFailed: "تعذّر الاختبار",
      switchFailed: "تعذّر التبديل",
      fixModelRetired: "الحل: افتح النافذة أدناه واحفظ مفتاحك مرة أخرى، فتستخدم AZEX النموذج الموصى به حاليًا لدى المزوّد. مفتاحك لا يزال صالحًا؛ أُوقف النموذج المحفوظ فقط.",
    },
  },
};

export default I18N_S7D_A;
